import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import ReactTooltip from 'react-tooltip';

import Text from '../Text';

import { useGetTileText } from './hooks/useGetTileText';
import { useGetTilePosition } from './hooks/useGetTilePosition';

export const TileActionText = ({
  campaignContainer,
  uuid,
  publishDate,
  tileStatus,
  postId,
}) => {
  const { currentPosition, tileCount } = useGetTilePosition({
    campaignContainer,
    uuid,
  });

  const tileText = useGetTileText({
    tileCount,
    publishDate,
    currentPosition,
    tileStatus,
    postId,
  });

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  return (
    <Wrapper>
      <Trans>{tileText}</Trans>
    </Wrapper>
  );
};

TileActionText.propTypes = {
  campaignContainer: PropTypes.string,
  publishDate: PropTypes.string,
  postId: PropTypes.number,
  tileStatus: PropTypes.string,
  uuid: PropTypes.string,
  autoSaved: PropTypes.object,
};

const Wrapper = styled(Text)`
  display: flex;
  align-items: center;
  gap: 4px;
  justify-self: center;
  grid-area: title;
`;
